<script lang="ts">
  import Text from '$components/utils/Text.svelte';
</script>

<div class="club-informations">
  <h2>
    <Text key="page.club.club-informations.heading" />
  </h2>

  <p>
    <Text key="page.club.club-informations.text" />
  </p>
</div>

<style lang="scss">
  .club-informations {
    padding-top: 171px;

    max-width: 800px;
    width: 50%;

    align-self: center;

    h2 {
      font-weight: 800;
      font-size: 28px;
      line-height: 42px;
    }

    p {
      padding-top: 36px;

      font-weight: 500;
      font-size: 17px;
      line-height: 34px;
    }
  }

  @include mobile {
    .club-informations {
      padding-top: 30px;

      h2 {
        font-weight: 800;
        font-size: 20px;
        line-height: 160%;
      }

      p {
        margin-top: 30px;

        font-weight: 500;
        font-size: 17px;
        line-height: 34px;
      }

      width: 90vw;
    }
  }
</style>
